import React from 'react';
import { Box, Checkbox, FormControlLabel, Typography } from '@mui/material';

/*
 * Phase A state shape decision:
 * Keep N/A state in a separate naFlags object (not fields.*_na keys) so
 * form payload fields stay unchanged until Phase B wiring.
 */

// Verified from Site table (2026-05-05): 14th Ave slug is exactly `14th-ave`.
export const NA_TOGGLE_SITE_ALLOWLIST = ['14th-ave'];

export function isNaToggleEnabledSite(siteSlug) {
  return !!siteSlug && NA_TOGGLE_SITE_ALLOWLIST.includes(siteSlug);
}

export function getPacketSiteSlug(packet) {
  if (!packet || typeof packet !== 'object') return '';
  const direct = packet.site_slug || packet.siteSlug || '';
  if (typeof direct === 'string' && direct.trim()) return direct.trim();
  // TODO(Phase B): require explicit site slug from backend payload and remove
  // this fa_* heuristic fallback.
  const forms = Array.isArray(packet.forms) ? packet.forms : [];
  const ids = forms.map((f) => String(f?.form_id || ''));
  if (ids.some((id) => id.startsWith('fa_'))) return '14th-ave';
  if (ids.some((id) => id.startsWith('wm_'))) return 'woodmere';
  if (ids.some((id) => id.startsWith('bs_'))) return '55th-street';
  return 'rockland';
}

export function computeIsRequired(fieldKey, fields, naFlags) {
  const skipped = !!naFlags?.[fieldKey];
  if (skipped) return false;
  const value = fields?.[fieldKey];
  if (typeof value === 'boolean') return !value;
  if (Array.isArray(value)) return value.length === 0;
  return !(String(value || '').trim());
}

export default function NaToggle({
  label = 'Not applicable',
  checked = false,
  onChange,
  targets = [],
  setF,
}) {
  const handleChange = (e) => {
    const next = !!e.target.checked;
    if (next && typeof setF === 'function') {
      targets.forEach((k) => {
        setF(k, '');
      });
    }
    if (typeof onChange === 'function') {
      onChange(next, { skipped: next, targets });
    }
  };

  return (
    <Box
      sx={{
        border: checked ? '1px solid #2e7d32' : '1px dashed #9e9e9e',
        backgroundColor: checked ? 'rgba(46, 125, 50, 0.10)' : 'transparent',
        borderRadius: 1,
        px: 1.25,
        py: 0.75,
        mt: 1,
      }}
    >
      <FormControlLabel
        control={<Checkbox size="small" checked={checked} onChange={handleChange} />}
        label={<Typography variant="body2">{label}</Typography>}
        sx={{ m: 0 }}
      />
    </Box>
  );
}
